import { render, staticRenderFns } from "./3rdRamListPop.vue?vue&type=template&id=e629fa26"
import script from "./3rdRamListPop.vue?vue&type=script&lang=js"
export * from "./3rdRamListPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e629fa26')) {
      api.createRecord('e629fa26', component.options)
    } else {
      api.reload('e629fa26', component.options)
    }
    module.hot.accept("./3rdRamListPop.vue?vue&type=template&id=e629fa26", function () {
      api.rerender('e629fa26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/3rdRamListPop.vue"
export default component.exports